import { useEffect } from 'react';

import { FORCE_CB_PAYMENT } from '../../constants/paymentMethods';

const ScriptContainer = () => {
    useEffect(() => {
        if (!FORCE_CB_PAYMENT) {
            initGooglePayTagScript();
            initApplePayTagScript();
        }
    }, []);

    const initGooglePayTagScript = () => {
        if (document.getElementById('google-pay-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-pay-sdk';
        script.src = 'https://pay.google.com/gp/p/js/pay.js';
        script.async = true;
        document.head.appendChild(script);
    };

    const initApplePayTagScript = () => {
        if (document.getElementById('apple-pay-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'apple-pay-sdk';
        script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
        script.async = true;
        document.head.appendChild(script);
    };

    return null;
};

export default ScriptContainer;



// WEBPACK FOOTER //
// ./src/components/funnel/ScriptContainer.js